require('./seminars-video.less');

$(function() {
    /**
     * При клике не элемент с видео получаем id элемента и делаем запрос
     * на получение контента для всплывашки с ее последующим отображением
     */

    $(document).on('click', '.js-modal-article-video', function(event) {
        event.preventDefault();

        var $this = $(this);
        var id = parseInt($this.data('id')) | 0;

        id > 0 && window.modalArticleVideo && window.modalArticleVideo(id);
    });

    /**
     * Пропорциональный ресайз видео проигрывателя
     */

    $(window).on('resize', function() {
        var element = document.querySelector('.jqi--article-video');
        if (element) {
            var $player, player, width, originWidth, originHeight;
            player = element.querySelector('iframe');

            // Ресайз битриксового плеера происходит не корректно, убираем
            //!player && (player = element.querySelector('div[id^="bx_flv_player"]'));

            if (player) {
                $player = $(player);
                width = $player.width();
                originWidth = parseInt($player.attr('width')) || parseInt(player.style.width);
                originHeight = parseInt($player.attr('height')) || parseInt(player.style.height);
            }

            if (width && width > 0 && originWidth > 0 && originHeight > 0) {
                var ratio = originWidth / originHeight;
                var height = width / ratio;

                $player.css({ 'max-height': height + 'px' });
            }
        }
    });
});

/**
 * Получаем через аякс контент всплывашки
 * и показываем всплывающее окно с видео плеером
 * @param id
 */

window.modalArticleVideo = function(id) {
    window.mxLoader = window.mxLoader || undefined;

    var url = '/ajax/component/maximaster:seminars.video/modal/?ID=' + id;

    // Ограничение минимального времени загрузки формы, прелоадер
    // Плохо выглядит, когда прелоадер очень быстро мелькает
    var time = new Date().getTime() + 400;
    window.mxLoader && window.mxLoader.show();

    $.ajax({
        url: url,
        success: function(result) {
            // Ограничение минимального времени загрузки формы
            time = time - new Date().getTime();
            time = time > 0 ? time : 0;

            setTimeout(function() {
                window.mxLoader && window.mxLoader.hide(0);
                $.prompt(result.html, {
                    classes: {
                        prompt: 'jqi--width-by-content jqi--article-video'
                    }
                });

                $(window).trigger('resize');
            }, time);
        }
    });
};



// WEBPACK FOOTER //
// ./blocks/seminars-video/seminars-video.js